const _require = require('@truqc/content-path'),
  getValue = _require.getValue;
const _require2 = require('lodash'),
  isArray = _require2.isArray;
const _require3 = require('../lib/evaluateSource'),
  evaluateSource = _require3.evaluateSource;

/**
  * @function evalute - evaluate extractBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  let result;
  const input = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  const valuePath = await evaluateSource(source.valuePath, content, parentContentPath, transientContext, nativeFunctions);
  if (isArray(input)) {
    result = input.map(item => getValue(valuePath, item)).filter(item => item !== undefined);
  } else {
    result = getValue(valuePath, input);
  }
  return result;
};
module.exports = {
  evaluate
};